import { useEffect, useState } from "react";
import axios from "axios";
import { Select } from 'flowbite-react';
import { VictoryBar, VictoryChart, VictoryAxis, VictoryTheme, VictoryLabel, VictoryGroup } from "victory";

const Charts = () => {
    const [chartData, setChartData] = useState({
        totalQuantityReceived: 0,
        totalQuantityEnattente: 0,
        totalStockCommerciaux: 0,
        totalRelatedPdvsSimsActivated: 0
    });
    const [user, setUser] = useState(null)
    const [relatedUsers, setRelatedUsers] = useState({
        relatedCommercials: [],
        relatedFranchises: [],
        relatedPdvs: []
    })
    const [selectedCommercial, setSelectedCommercial] = useState("");
    const [selectedCommercialRoleId,setSelectedCommercialRoleId] = useState("")
    const [selectedFranchise, setSelectedFranchise] = useState("");
    const [selectedFranchiseRoleId,setSelectedFranchiseRoleId] = useState("")
    const [selectedPDV, setSelectedPDV] = useState("");
 
    // i want to get the role id of the selected commercial, franchise and pdv from accessing the ._id direcltly in the coressponding objects

    const fetchCurrentUser = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}auth/check/`,
                { withCredentials: true }
            );
            setUser(response.data.user)
        } catch (error) {
            console.log(error)
        }
    }

    const fetchRelatedUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}getRelatedUsersForChart`, { withCredentials: true })
            setRelatedUsers(response.data)
        } catch (error) {
            console.log(error)
        }
    }

    const fetchChartData = async () => {
        try {
            let url = `${process.env.REACT_APP_BACKEND_URL}getChartData/?`;

            if (selectedCommercial) {
                url += `&commercial=${selectedCommercial}`;
            }
            if (selectedFranchise) {
                url += `&franchise=${selectedFranchise}`;
            }
            if (selectedPDV) {
                url += `&pdv=${selectedPDV}`;
            }

            const response = await axios.get(url, { withCredentials: true });
            setChartData(response.data);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchCurrentUser();
        fetchRelatedUsers();
    }, []);

    useEffect(() => {
        fetchChartData();
    }, [selectedCommercial, selectedFranchise, selectedPDV]);

    
    const pieData = [
        { x: "Recus", y: chartData[Object.keys(chartData)[0]] },
        { x: "Recouvrées", y: chartData[Object.keys(chartData)[4]] },
        { x: "En attente", y: chartData[Object.keys(chartData)[1]] },
        { x: "Stock", y: chartData[Object.keys(chartData)[2]] },
        { x: "Activations", y: chartData[Object.keys(chartData)[3]] },
    ];

    
    return (
        <div className="h-full w-full bg-white dark:bg-gray-800 dark:text-white p-6 shadow-md mt-3 flex flex-col gap-2 rounded-md">
            <div className="text-2xl font-bold">
                Charts
            </div>
            <div className="flex flex-col md:flex-row gap-2">
              {!["COMMERCIAL","FRANCHISE","PDV"].includes(user?.role) && <Select
                    id="commercial"
                    value={selectedCommercial}
                    onChange={(e) => {
                        const selectedCommercialObj = relatedUsers.relatedCommercials.find(
                            commercial => commercial.User._id === e.target.value
                        );
                        setSelectedCommercial(e.target.value);
                        setSelectedCommercialRoleId(selectedCommercialObj?._id || "");
                    }}
                    className="w-full"
                >
                    <option value="">Select Commercial</option>
                    {relatedUsers?.relatedCommercials?.map((commercial) => (
                        <option key={commercial._id} value={commercial?.User?._id}>
                            {commercial?.User?.username}
                        </option>
                    ))}
                </Select>}

               { !["FRANCHISE","PDV"].includes(user?.role)&&<Select
                    id="franchise"
                    value={selectedFranchise}
                    onChange={(e) => {
                        const selectedFranchiseObj = relatedUsers?.relatedFranchises?.find(
                            franchise => franchise?.user?._id === e.target.value
                        );
                        setSelectedFranchise(e.target.value);
                        setSelectedFranchiseRoleId(selectedFranchiseObj?._id || "");
                    }}
                    className="w-full"
                    disabled = { ["ADMIN"].includes(user?.role) ? selectedCommercial.length === 0 : false}
                >
                    <option value="">Select Franchise</option>
                    {selectedCommercialRoleId.length > 0 ? relatedUsers?.relatedFranchises?.filter((f)=>f.user && f.commercial === selectedCommercialRoleId)?.map((franchise) => (
                        <option key={franchise._id} value={franchise?.user?._id}>
                            {franchise?.pos_franchise_id?.name}
                        </option>
                    )) : relatedUsers?.relatedFranchises?.map((franchise) => (
                        <option key={franchise._id} value={franchise?.user?._id}>
                            {franchise?.pos_franchise_id?.name}
                        </option>
                    ))}
                </Select>}

                <Select
                    id="pdv"
                    value={selectedPDV}
                    onChange={(e) => {
                        const selectedPDVObj = relatedUsers.relatedPdvs.find(
                            pdv => pdv.user._id === e.target.value
                        );
                        setSelectedPDV(e.target.value);
                    }}
                    className="w-full"
                    disabled = {["Franchise","ADMIN","COMMERCIAL"].includes(user?.role) ? selectedFranchise.length === 0 : false }
                >
                    <option value="">Select PDV</option>
                    {selectedFranchiseRoleId.length > 0 ? relatedUsers?.relatedPdvs?.filter((p)=>p.franchise_id === selectedFranchiseRoleId)?.map((pdv) => (
                        <option key={pdv._id} value={pdv?.user?._id}>
                            { pdv?.pos_agent_id?.first_name && pdv?.pos_agent_id?.last_name ? pdv?.pos_agent_id?.first_name + " " + pdv?.pos_agent_id?.last_name : pdv?.pos_agent_id?.username}
                        </option>
                    )) : relatedUsers?.relatedPdvs?.map((pdv) => (
                        <option key={pdv._id} value={pdv?.user?._id}>
                            { pdv?.pos_agent_id?.first_name && pdv?.pos_agent_id?.last_name ? pdv?.pos_agent_id?.first_name + " " + pdv?.pos_agent_id?.last_name : pdv?.pos_agent_id?.username}
                        </option>
                    ))}
                </Select>
            </div>
            <div className="grid md:grid-cols-2 gap-1 dark:bg-gray-800 bg-gray-200 p-1 rounded-md ">
            <div className="flex flex-col gap-2 items-center justify-center">
                    {pieData?.map((item, index) => (
                        <div key={item.x} className="flex flex-row items-center p-2 justify-between rounded-md w-full"
                            style={{ backgroundColor: ["#4F46E5", "#F59E0B", "#10B981", "#EF4444","blue"][index] }}>
                            <span className="text-white text-sm">{item.x ==="Activations" ? "Sims Activées" : item.x === "Recus" ? "Total des transactions Recus" : item.x === "En attente" ? "Total des transactions en attente"
                            : item.x === "Recouvrées" ? "Total des transactions Recouvrées" : "Stock Actuel"}</span>
                            <span className="text-white text-xs font-bold">{item.y}</span>
                        </div>
                    ))}
                </div>
                <div className=" md:h-[500px] h-[300px] w-full">
                    <VictoryChart
                        theme={VictoryTheme.material}
                        domainPadding={40}
                        padding={{ top: 100, bottom: 80, left: 80, right: 80 }}
                        width={800}
                        height={500}
                    >
                        <VictoryAxis
                            tickFormat={(t) => t}
                            style={{
                                tickLabels: { 
                                    fontSize: 14,
                                    angle: -45,
                                    fill: "black",
                                    padding: 10
                                },
                                axis: { stroke: "black" }
                            }}
                        />
                        <VictoryAxis
                            dependentAxis
                            style={{
                                tickLabels: { 
                                    fontSize: 14,
                                    fill: "black",
                                    padding: 10
                                },
                                axis: { stroke: "black" }
                            }}
                        />
                        <VictoryGroup offset={30}>
                            <VictoryBar
                                data={pieData}
                                style={{
                                    data: {
                                        fill: ({ index }) => ["#4F46E5", "#F59E0B", "#10B981", "#EF4444","blue"][index],
                                        width: 60
                                    }
                                }}
                                labels={({ datum }) => `${datum.x}\n${datum.y}`}
                                labelComponent={
                                    <VictoryLabel
                                        dy={-30}
                                        style={{ 
                                            fill: "white", 
                                            fontSize: 14,
                                            fontWeight: "bold",
                                            textAnchor: "middle"
                                        }}
                                        backgroundStyle={{
                                            fill: "rgba(0, 0, 0, 0.5)",
                                            stroke: "white",
                                            strokeWidth: 1
                                        }}
                                        backgroundPadding={{ left: 8, right: 8, top: 4, bottom: 4 }}
                                    />
                                }
                            />
                        </VictoryGroup>
                    </VictoryChart>
                </div>
               
            </div>
        </div>
    )
}

export default Charts;